import React from "react";

import "./CreditsCount.css";

export function getCreditsCountStatus(count, warningThreshold = 10) {
  const value = Math.max(Number(count) || 0, 0);
  if (value <= 0) return "empty";
  if (warningThreshold != null && value <= warningThreshold) return "warning";
  return "default";
}

export function mapUsageStatusToCreditsTone(status) {
  if (status === "critical") return "empty";
  if (status === "warning") return "warning";
  return "default";
}

function formatCount(value) {
  return Math.max(Number(value) || 0, 0).toLocaleString();
}

export function resolveRemainingCredits({
  used = 0,
  poolCredits,
  total = 0,
} = {}) {
  const pool = Number(poolCredits ?? total) || 0;
  const consumed = Number(used) || 0;
  return Math.max(pool - consumed, 0);
}

export function CreditsCountRatio({
  used = 0,
  total = 0,
  tone = "default",
  className = "",
  label = "",
}) {
  const resolvedTone = ["default", "empty"].includes(tone) ? tone : "default";

  const rootClass = [
    "CreditsCountRatio",
    `CreditsCountRatio--${resolvedTone}`,
    className,
  ].filter(Boolean).join(" ");
  const text = label
    ? `${formatCount(used)} ${label}`
    : `${formatCount(used)}/${formatCount(total)}`;

  return (
    <span className={rootClass}>
      {text}
    </span>
  );
}

export default function CreditsCount({
  count = 0,
  status,
  warningThreshold = 10,
  label = "remaining",
  className = "",
}) {
  const value = Math.max(Number(count) || 0, 0);
  const resolvedStatus = status || getCreditsCountStatus(value, warningThreshold);
  const tone = ["default", "warning", "empty"].includes(resolvedStatus)
    ? resolvedStatus
    : "default";

  const rootClass = [
    "CreditsCount",
    `CreditsCount--${tone}`,
    className,
  ].filter(Boolean).join(" ");

  return (
    <span className={rootClass}>
      {`${formatCount(value)} ${label}`}
    </span>
  );
}

export function CreditsCountGroup({
  used = 0,
  total = 0,
  poolCredits,
  remaining,
  status,
  warningThreshold = 10,
  muteEmpty = true,
  label = "remaining",
  usedLabel = "",
  className = "",
}) {
  const resolvedRemaining = remaining ?? resolveRemainingCredits({
    used,
    poolCredits,
    total,
  });
  const creditsTone = status
    ? mapUsageStatusToCreditsTone(status)
    : getCreditsCountStatus(resolvedRemaining, warningThreshold);
  const resolvedCreditsTone = !muteEmpty && creditsTone === "empty" ? "default" : creditsTone;
  const ratioTone = muteEmpty && resolvedCreditsTone === "empty" ? "empty" : "default";

  const rootClass = [
    "CreditsCountGroup",
    className,
  ].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <CreditsCountRatio
        used={used}
        total={total}
        tone={ratioTone}
        label={usedLabel}
      />
      <CreditsCount
        count={resolvedRemaining}
        status={resolvedCreditsTone}
        label={label}
      />
    </div>
  );
}
